export default __webpack_public_path__ + "static/CoopGameplay-3ad30d01c6c932946532f5b7bca60583.webp";